import React,{useState,useEffect,CSSProperties} from 'react'
import "../styles/Projects.css"

import PacmanLoader	 from "react-spinners/PacmanLoader";
import projects from './Data';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBookOpen , faWindowClose } from '@fortawesome/free-solid-svg-icons'
import useHover from '../Hooks/useHover';
import Project from './Project';



const override: CSSProperties = {
    display: "block",
    margin: "0 auto",
    borderColor: "red",
    marginTop:"21rem",
  };


function Projects() {
    let [loading, setLoading] = useState(true);
    const [flag,onHover] = useHover(false);

    

    useEffect(()=>{
        setTimeout(()=>{
            setLoading(false);
        },1200)
    })
  
    return (
        <>
         {loading ?  <PacmanLoader color={"#feb800"} loading={true} cssOverride={override} size={25}/>
         :
        <div className="Project">
           <h1 className="Project__heading">Projects </h1> 
           <div className="projects">
             {
                projects.map((p,index)=>{
                    return (
                        <Project p={p}/>
                     )
                })
             }
           </div>
           </div>}
           </>
    )
}

export default Projects
